export const addIfNotPresent = <T>(array: T[], toAdd: T | undefined) => {
  if (toAdd && array.indexOf(toAdd) === -1) array.push(toAdd);
};
